import { useEffect } from "react";
import "./App.css";
import axios from "axios";
import IngeniousCapital from './components/IngeniousCapital';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return <IngeniousCapital />;
};

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;